// HorizFeaturesDialog.tsx — Up to 19 horizontal feature strips (fhvar)

import DialogBase from './DialogBase';
import { SlotEditor } from './SlotEditor';
import { usePendingSlot } from './usePendingSlot';
import { useShallowStore } from '../store/useStore';

const FIELDS = [
  { key: 'mark',    label: 'Mark',    type: 'text'   as const },
  { key: 'y',       label: 'Y Pos',   type: 'number' as const, unit: '"', min: 0 },
  { key: 'height',  label: 'Height',  type: 'number' as const, unit: '"', min: 0 },
  { key: 'depth',   label: 'Depth',   type: 'number' as const, unit: '"', min: 0 },
  { key: 'xStart',  label: 'X Start', type: 'number' as const, unit: '"', min: 0 },
  { key: 'xEnd',    label: 'X End',   type: 'number' as const, unit: '"', min: 0, step: 0.5 },
];

export default function HorizFeaturesDialog() {
  const { ui, project, updatePanel } = useShallowStore(s => ({
    ui: s.ui, project: s.project, updatePanel: s.updatePanel,
  }));
  const panel = project?.panels.find(p => p.id === ui.activePanelId);
  const [slots, setSlots] = usePendingSlot('fhvar', panel?.fhvar ?? [],
    (_px, py, mark) => ({ mark, y: py }),
    { mark: '', type: 'reveal' as const, y: 0, width: 0, height: 0, depth: 0.75, xStart: 0, xEnd: 0 });
  if (!panel) return null;

  return (
    <DialogBase title="Horizontal Feature Strips (19 max)" onOk={() => updatePanel(panel.id, { fhvar: slots })}>
      <SlotEditor
        slots={slots}
        fields={FIELDS}
        maxSlots={19}
        onChange={v => setSlots(v)}
        defaultData={() => ({ mark: '', type: 'reveal' as const, y: 0, width: 0, height: 0, depth: 0.75, xStart: 0, xEnd: 0 })}
        label="FH"
      />
    </DialogBase>
  );
}
